var Measurements;
(function (Measurements) {
    Measurements["METERS"] = "m";
    Measurements["CENTIMETERS"] = "cm";
    Measurements["YARDS"] = "yd";
    Measurements["FEET"] = "ft";
    Measurements["INCHES"] = "in";
})(Measurements || (Measurements = {}));
export var MeasurementUnits;
(function (MeasurementUnits) {
    MeasurementUnits["METRIC"] = "metric";
    MeasurementUnits["IMPERIAL"] = "imperial";
})(MeasurementUnits || (MeasurementUnits = {}));
var MeasurementConversions;
(function (MeasurementConversions) {
    MeasurementConversions[MeasurementConversions["INCH_TO_METERS"] = 0.0254] = "INCH_TO_METERS";
    MeasurementConversions[MeasurementConversions["INCH_TO_YARDS"] = 36] = "INCH_TO_YARDS";
    MeasurementConversions[MeasurementConversions["INCH_TO_FEET"] = 12] = "INCH_TO_FEET";
    MeasurementConversions[MeasurementConversions["METERS_TO_INCH"] = 39.37008] = "METERS_TO_INCH";
})(MeasurementConversions || (MeasurementConversions = {}));
export var formatMeasurement = function (measurement, units, hasSubUnits) {
    if (hasSubUnits === void 0) { hasSubUnits = true; }
    if (measurement < 0)
        return '';
    if (measurement > 2000 && units === 'metric' && !hasSubUnits) {
        return "".concat(Math.round(measurement * MeasurementConversions.INCH_TO_METERS)).concat(Measurements.METERS);
    }
    else if (measurement > 2000 && units === 'metric') {
        return "".concat((measurement * MeasurementConversions.INCH_TO_METERS).toFixed(2)).concat(Measurements.METERS);
    }
    else if (measurement > 2000) {
        return "".concat(Math.round(measurement / MeasurementConversions.INCH_TO_YARDS)).concat(Measurements.YARDS);
    }
    if (units === 'metric' && !hasSubUnits) {
        return "".concat(Math.round(measurement * MeasurementConversions.INCH_TO_METERS)).concat(Measurements.METERS);
    }
    else if (units === 'metric') {
        return "".concat((measurement * MeasurementConversions.INCH_TO_METERS).toFixed(2)).concat(Measurements.METERS);
    }
    return "".concat(Math.floor(measurement / MeasurementConversions.INCH_TO_FEET)).concat(Measurements.FEET, " ").concat(Math.round(measurement % MeasurementConversions.INCH_TO_FEET)).concat(Measurements.INCHES);
};
